// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".currency-group-page__item[data-v-1dcdfb66] {\n  white-space: nowrap;\n}\n[data-v-1dcdfb66] .v-data-table thead th {\n  white-space: nowrap;\n}", ""]);
// Exports
module.exports = exports;
